import { EdgeItemsType } from 'data/types';
import { OpeningRunLayoutType } from 'utils/opening-run-layout-types';
import { EdgeRunType } from 'utils/opening-position-types';

export function openingLayoutsFromEdgeItems(
  edgeItems: EdgeItemsType,
  edgeRuns: EdgeRunType[]
): OpeningRunLayoutType[] {
  const usedCardinals = new Set<EdgeRunType['edge']>();
  return edgeRuns.map((run) => {
    if (usedCardinals.has(run.edge)) {
      return { run, items: [] };
    }
    usedCardinals.add(run.edge);
    return { run, items: edgeItems[run.edge] };
  });
}
